module.exports = __webpack_public_path__ + "img/coming-soon-dark.75b38061.svg";